<template>
  <div id="app" class="pdf" :style="scaleStyle" ref="previewMain">
    <DesignRirekisho001PreviewDoc
      ref="previewDoc"
      :format-data="formatData"
      :basic-data="basicData"
      :preview-scale="previewScale"
      :current-card-id="currentCardId"
      :id-prefix="idPrefix"
      :is-sample="isSample"
      :format-id="formatId"
    />
  </div>
</template>
<script setup lang="ts">
import { computed, ref } from 'vue'
import DesignRirekisho001PreviewDoc from '@/components/format-edit/design-rirekisho/DesignRirekisho001PreviewDoc.vue'

type FormatPreviewSfcProps = {
  formatData: Record<string, any>
  basicData: Record<string, any>
  previewScale?: number
  currentCardId?: string | string[]
  idPrefix?: string
  isSample?: boolean
  formatId?: string
}

const props = withDefaults(defineProps<FormatPreviewSfcProps>(), {
  previewScale: 1,
  currentCardId: '',
  idPrefix: '',
  isSample: false
})

const previewDoc = ref<{
  checkValid?: () => void
  errorMessages?: Record<string, string>
  optionItems?: { commuteDescription: boolean }
} | null>(null)
const scaleStyle = computed(() => ({
  transform: `scale(${props.previewScale ?? 1})`,
  'transform-origin': 'top left'
}))

function checkValid() {
  previewDoc.value?.checkValid?.()
}

defineExpose({
  checkValid,
  get errorMessages() {
    return previewDoc.value?.errorMessages
  },
  get optionItems() {
    return previewDoc.value?.optionItems
  }
})
</script>
